// extracted by mini-css-extract-plugin
export var cardHeader = "_hu-0";
export var reorderHandle = "_hu-3";
export var titleArea = "_hu-1";
export var titleAreaWithHandle = "_hu-2";